import { IResultData } from './SupportHoursTypes';

export function transformFilterData(
  columnData: any[],
  mobileData: any[]
): IResultData[] {
  const result: IResultData[] = [];
  columnData.forEach(
    (column: { filterable: boolean; Header: any; accessor: any }) => {
      if (column.filterable === true) {
        const columnHeader = column.Header;
        const columnAccessor = column.accessor;

        const optionList: string[] = [];
        const transformedColumns: { option: string; selected: boolean }[] = [];

        const sortFunction = (
          itemA: { [x: string]: string },
          itemB: { [x: string]: any }
        ) => {
          return itemA[columnAccessor]?.localeCompare(
            itemB[columnAccessor],
            'en',
            {
              numeric: true,
              sensitivity: 'base',
            }
          );
        };
        const sortedMobileDataCopy = Array.from(mobileData);
        sortedMobileDataCopy.sort(sortFunction);
        const sortedDataCopy = sortedMobileDataCopy;

        sortedDataCopy.forEach((dataItem: { [x: string]: any }) => {
          dataItem[columnAccessor] &&
          typeof dataItem['original' + columnAccessor] === 'object'
            ? optionList.push(
                dataItem['original' + columnAccessor].props.children
              )
            : optionList.push(
                dataItem['original' + columnAccessor] ||
                  dataItem[columnAccessor]
              );
        });

        let uniqueOptionSet = new Set(optionList);
        uniqueOptionSet.forEach((uniqueOption) => {
          transformedColumns.push({ option: uniqueOption, selected: false }); // Set selected as boolean false
        });

        result.push({
          header: columnHeader,
          cols: transformedColumns,
          accessor: columnAccessor,
        });
      }
    }
  );

  return result;
}

export function filterData(data: any, filters: any[]) {
  let filteredData = data;

  filters.forEach((filterItem: { cols: any[]; accessor: string }) => {
    if (filterItem.cols) {
      const selectedFilterOptions = filterItem.cols
        .filter((filterOption: { selected: any }) => filterOption.selected)
        .map((filterOption: { option: any }) => filterOption.option);
      if (selectedFilterOptions.length > 0) {
        filteredData = filteredData.filter((rowItem: { [x: string]: any }) => {
          return selectedFilterOptions.includes(
            typeof rowItem['original' + filterItem.accessor] === 'object'
              ? rowItem['original' + filterItem.accessor].props.children
              : rowItem['original' + filterItem.accessor] ||
                  rowItem[filterItem.accessor]
          );
        });
      }
    }
  });
  return { filteredData };
}
